


































































































































































import Vue from 'vue'
import { loginWithUserPhone, exchangeFacebookToken } from '@/api/auth'
import { ILoginRequest, IFacebookExchangeRequest } from '@/interfaces/auth'
import { mapMutations } from 'vuex'
import Facebook from '@/utils/facebook'
import Logo from '@/components/Logo.vue'

import { getCountryCodeByPhoneCode, phoneAreaOptions } from '@/utils/data'
import { getAndSetHostIdFromLocalStorage } from '@/utils'
import { MetaInfo } from 'vue-meta/types/vue-meta'

export default Vue.extend({
  name: 'Login',
  components: { Logo },
  props: {
    redirect: {
      type: String,
      default: undefined
    }
  },
  data () {
    return {
      nuphotoWeb: 'https://nuphoto.com.tw/chrome_dev' as string, // for test
      phoneNumberCode: '+886' as string,
      phoneNumber: '' as string,
      password: '' as string,
      errorMessage: '' as string,
      isPeerPassword: false as boolean,
      isLoading: false as boolean,
      isFacebookLoading: false as boolean,
      checkFacebookInitTimerId: null as number | null,
      phoneAreaOptions
    }
  },
  metaInfo (): MetaInfo {
    return {
      title: '登入',
      titleTemplate: '%s | nuPhoto 拍立洗'
    }
  },
  computed: {
    togglePeerPasswordIcon (): string {
      return `eye${this.isPeerPassword ? '-slash' : ''}`
    },
    togglePeerPasswordInput (): string {
      return `${this.isPeerPassword ? 'text' : 'password'}`
    },
    getRedirectPath (): any {
      // 設置重新導向，若在首頁、註冊、登入頁面做切換不需設置 redirect，其他頁面則需要重新導向，若已經設置重新導向頁面，則註冊、登入切換時，並不會互相把自己的頁面給放進重新導向內
      const disableRedirectPaths = ['/', '/signup', '/login']
      if (disableRedirectPaths.some(disableRedirectPath => this.$route.path === disableRedirectPath)) {
        // 當前路徑是禁止重定向的路徑之一
        const query = this.$route.query
        // 2024/08: 支援query string 'product' & 'route' (nuphoto-web 跳轉)
        if (query.redirect !== undefined || query.product !== undefined || query.route !== undefined) {
          // 如果存在任何一個查詢參數，則返回包含這些參數的對象
          return {
            ...(query.redirect && { redirect: query.redirect }),
            ...(query.product && { product: query.product }),
            ...(query.route && { route: query.route })
          }
        }
        return null // 如果沒有任何相關查詢參數，返回 null
      } else {
        // 如果不是禁止重定向的路徑，返回當前路徑作為重定向
        return { redirect: this.$route.path }
      }
    }
  },
  created () {
    this.clearForm()
    this.isFacebookLoading = false
    // The code below is obsoleted.
    /*
    this.checkFacebookInitTimerId = setInterval(() => {
      this.isFacebookLoading = !Facebook.isFacebookInit()
      if (!this.isFacebookLoading && this.checkFacebookInitTimerId) {
        clearInterval(this.checkFacebookInitTimerId)
      }
    }, 100)
    */

    // handle redirect logic for FB login
    var queryString = window.location.search
    if (queryString) {
      const search = new URLSearchParams(window.location.search)
      if (search.has('redirect')) {
        localStorage.setItem('fbQuery', `redirect=${search.get('redirect')}`)
      } else if (search.has('product')) {
        var fbQuery = `product=${search.get('product')}`
        if (search.has('route')) {
          fbQuery += `&route=${search.get('route')}`
        }
        localStorage.setItem('fbQuery', fbQuery)
      }
    }

    const code = this.$route.query.code as string
    const error = this.$route.query.error
    const errorDescription = this.$route.query.errorDescription
    if (code !== undefined && !this.$store.getters.isLogin) {
      this.handleAccessUserProfileByAccessToken(code)
    } else {
      if (errorDescription !== null) {
        this.$store.commit('logger/PUSH_LOG', `Facebook login failed: ${error}`)
        this.$store.commit('logger/PUSH_LOG', errorDescription)
        this.$bvModal.msgBoxOk(errorDescription as string, {
          centered: true,
          footerClass: 'msgbox-ok-footer',
          okTitle: '確定'
        })
      }
    }
  },
  methods: {
    ...mapMutations({
      setToken: 'SET_TOKEN',
      setUserInfo: 'SET_USER_INFO',
      setCoinLeft: 'SET_COIN_LEFT',
      setNuCoin: 'SET_NU_COIN',
      setNuCoinExpireTime: 'SET_NU_COIN_EXPIRE_TIME',
      setCountry: 'SET_COUNTRY'
    }),
    transformPhoneNumberByArea (phoneNumberCode: string) {
      if (phoneNumberCode === '+886') {
        this.phoneNumber = this.phoneNumber.replace(/^\+?886/, '')
        if (this.phoneNumber.charAt(0) === '9') {
          this.phoneNumber = this.phoneNumber.padStart(10, '0')
        }
        return this.phoneNumber
      } else {
        return phoneNumberCode.concat(this.phoneNumber)
      }
    },
    async handleLogin () {
      this.errorMessage = ''
      if (this.isEmpty(this.phoneNumber)) {
        this.errorMessage = '請輸入會員手機'
        return
      } else if (this.isEmpty(this.password)) {
        this.errorMessage = '請輸入密碼'
        return
      }
      try {
        this.isLoading = true
        const requestBody = {
          account: this.transformPhoneNumberByArea(this.phoneNumberCode),
          upass: this.password,
          type: '0'
        } as ILoginRequest

        const { data } = await loginWithUserPhone(requestBody)
        if (data.flag === 1) {
          throw new Error(data.msg)
        } else {
          this.$store.commit('logger/PUSH_LOG', `Phone login: ${JSON.stringify(data)}`)
          this.setToken(data)
          this.setUserInfo({
            account: this.transformPhoneNumberByArea(this.phoneNumberCode),
            expireTime: data.expire_time
          })
          if (this.$store.getters.country === null) {
            this.setCountry(getCountryCodeByPhoneCode(this.phoneNumberCode))
          }
          this.clearForm()
          const coinLeft = parseInt(data.coin_left) || 0
          const coinValue = parseInt(data.coin_value) || 0
          let text = '您已登入成功，即將跳轉至主頁面'
          if (coinLeft > 0) { text = `您的帳號中有 ${coinLeft} 點數，可折抵消費 ${coinValue} 元。` }
          this.setCoinLeft(coinLeft)
          this.setNuCoin(parseInt(data.nucoin) || 0)
          this.setNuCoinExpireTime(data.nucoin_expire_time)
          await this.displayLoginSuccessModal(text)
            .then(() => {
              const product = this.$route.query.product
              const route = this.$route.query.route
              if (product) {
                let url = `${this.nuphotoWeb}?product=${product}`
                if (route) {
                  url += `&route=${route}`
                }
                window.location.href = url
              } else {
                this.$router.push({ path: this.redirect || '/' })
              }
            })
        }
      } catch (error) {
        this.$store.commit('logger/PUSH_LOG', `Phone login failed: ${error}`)
        this.$bvModal.msgBoxOk(error.message, {
          centered: true,
          footerClass: 'msgbox-ok-footer',
          okTitle: '確定'
        })
      } finally {
        this.isLoading = false
      }
    },
    handleFacebookLogin () {
      this.isFacebookLoading = true
      window.location.href = this.getFacebookDialogOAuthUrl()
    },
    getFacebookDialogOAuthUrl () {
      if (this.$route.query.redirect) {
        const redirectStr = JSON.stringify({
          redirect: this.$route.query.redirect,
          hostId: getAndSetHostIdFromLocalStorage(),
          path: this.$route.path
        })
        return Facebook.getDialogOAuthUrl(redirectStr)
      }
      const redirectStr = JSON.stringify({
        hostId: getAndSetHostIdFromLocalStorage(),
        path: this.$route.path
      })
      return Facebook.getDialogOAuthUrl(redirectStr)
    },
    async handleAccessUserProfileByAccessToken (code: string) {
      this.isFacebookLoading = true
      try {
        const exchangeRequestBody = {
          code,
          redirect_uri: `${process.env.VUE_APP_HOST}${process.env.VUE_APP_PATH}/login`
        } as IFacebookExchangeRequest
        const { data } = await exchangeFacebookToken(exchangeRequestBody)
        if (data.flag === 1) {
          throw new Error(data.msg)
        }
        const result = await Facebook.loginWithGraphApi(data.token)
        if (result) {
          this.isFacebookLoading = false
          const coinLeft = parseInt(result.coin_left) || 0
          const coinValue = parseInt(result.coin_value) || 0
          let text = '您已登入成功'
          if (coinLeft > 0) { text = `您的帳號中有 ${coinLeft} 點數，可折抵消費 ${coinValue} 元。` }
          this.setCoinLeft(coinLeft)
          this.setNuCoin(parseInt(result.nucoin) || 0)
          this.setNuCoinExpireTime(result.nucoin_expire_time)
          await this.displayLoginSuccessModal(text)
            .then(() => {
              var fbQuery = new URLSearchParams(localStorage.getItem('fbQuery') || '')
              localStorage.removeItem('fbQuery')

              if (fbQuery.has('product')) {
                let url = `${this.nuphotoWeb}?product=${fbQuery.get('product')}`
                if (fbQuery.has('route')) {
                  url += `&route=${fbQuery.get('route')}`
                }
                window.location.href = url
              } else {
                this.$router.push({ path: fbQuery.get('redirect') || '/' })
              }
            })
        }
      } catch (error) {
        this.$bvModal.msgBoxOk(error.message, {
          centered: true,
          footerClass: 'msgbox-ok-footer',
          okTitle: '確定'
        }).then(() => {
          this.isFacebookLoading = false
        })
      }
    },
    isEmpty (target: string): boolean | null {
      return target.length === 0 || !target.trim()
    },
    clearForm () {
      this.phoneNumber = ''
      this.errorMessage = ''
      this.password = ''
      this.isPeerPassword = false
    },
    displayLoginSuccessModal (displayText: string) {
      if (displayText.length === 0) { throw new Error('視窗訊息不可為空！') }
      return this.$bvModal.msgBoxOk(displayText || '', {
        title: '登入成功',
        centered: true,
        footerClass: 'msgbox-ok-footer',
        okTitle: '確定'
      })
    }
  }
})
